module.exports = __webpack_public_path__ + "static/media/personalization-bootcamp.b35bb104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personalization-bootcamp.jpg
// module id = 1022
// module chunks = 0